<script>
    import { fade } from 'svelte/transition'

    /**@type {{progress?: number, size?: 'xsmall' | 'small' | 'medium' | 'large'}}*/
    let { progress = null, size = 'small' } = $props()
</script>

<div class="flex h-full w-full items-center justify-center" title="{progress}%" in:fade={{ duration: 120 }}>
    <div class="spinner bg-primary {size}"></div>
</div>

<style>
    @reference '../../../app.css';
    .spinner.xsmall {
        @apply h-4 w-4;
    }
    .spinner.small {
        @apply h-6 w-6;
    }
    .spinner.medium {
        @apply h-8 w-8;
    }
    .spinner.large {
        @apply h-10 w-10;
    }

    .spinner {
        box-sizing: border-box;
        border-radius: 50%;
        animation: 1.2s rotate infinite linear;
    }
    .spinner::before {
        content: '';
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        height: 70%;
        width: 70%;
        background: #fff;
        border-radius: 50%;
    }
    .spinner::after {
        content: '';
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        height: 14%;
        width: 14%;
        @apply bg-primary-300;
        border-radius: 50%;
    }
    @keyframes rotate {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>
